import { render, staticRenderFns } from "./ElEstageInternalEmbed.vue?vue&type=template&id=0c2a7bd8"
import script from "./ElEstageInternalEmbed.vue?vue&type=script&lang=js"
export * from "./ElEstageInternalEmbed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports